<template>
  <div class="invite-earn-root" :class="{ 'is-echo-variant': isEchoVariant }">
    <div class="custom-nav-block" :class="[scrollTop ? 'nav-scrolling' : 'nav-default']" :style="`padding-top:${topBarHeight}px`">
      <van-nav-bar class="van-bar" title="" @click-left="goBack">
        <template #left>
          <img class="left-nav" src="@/assets/packageAssets/common/arrow00.webp" alt="" />
        </template>
      </van-nav-bar>
    </div>

    <div class="event-head">
      <img v-if="heroBg" class="hero-bg" :src="heroBg" alt="" />
      <div class="head-content" :style="{ paddingTop: `${topBarHeight + 46 - 32}px` }">
        <div class="title-banner">
          <img class="title-banner-bg" src="./images/tit-bar.webp" alt="" />
          <div class="title-banner-text">
            <MyPLabel
              class="title-banner-label"
              :str="$t('lang.InviteEarn.k002')"
              :numsOption="[
                { value: totalReward, class: 'title-reward' },
                { value: coinsWord, class: 'title-reward' },
              ]"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="event-body">
      <div ref="mainCard" class="main-card" :style="mainCardMeasured ? { minHeight: mainCardMinHeight } : null">
        <div class="reward-progress">
          <div class="section-title">
            <span class="title-star"></span>
            <span class="title-text">{{ $t('lang.InviteEarn.k005') }}</span>
            <span class="title-star"></span>
          </div>
          <div class="stats-row">
            <div class="stat-col">
              <div class="stat-value">{{ thousandthDigit(homeData.totalInvitees) }}</div>
              <div class="stat-label">{{ $t('lang.InviteEarn.k006') }}</div>
            </div>
            <div class="stat-divider"></div>
            <div class="stat-col">
              <div class="stat-value">
                <span class="stat-num">{{ thousandthDigit(homeData.coinsEarned) }}</span>
                <img class="stat-coin" :src="getMatchImg('coin')" alt="" />
              </div>
              <div class="stat-label">{{ $t('lang.InviteEarn.k007') }}</div>
            </div>
          </div>
        </div>

        <div class="how-to-earn">
          <div class="section-title section-title-left">
            <span class="title-text">{{ $t('lang.InviteEarn.k009') }}</span>
          </div>
          <div class="task-list">
            <div v-for="(task, index) in homeData.tasks" :key="index" class="task-item">
              <img class="task-icon" :src="taskIconSrc(index)" alt="" />
              <div class="task-text">
                <div class="task-title">{{ task.title }}</div>
                <div class="task-desc">{{ task.desc }}</div>
              </div>
              <div class="task-reward">
                <span class="reward-num">+{{ task.reward }}</span>
                <img class="reward-coin" :src="getMatchImg('coin')" alt="" />
              </div>
            </div>
          </div>
        </div>

        <div class="invite-btn-spacer"></div>
      </div>
    </div>

    <div class="invite-btn-fixed">
      <button type="button" class="invite-btn" @click="handleInvite">
        <img class="invite-btn-bg" src="./images/btn.webp" alt="" />
        <span class="invite-btn-text">{{ $t('lang.InviteEarn.k014') }}</span>
      </button>
      <div class="invite-btn-block"></div>
    </div>
  </div>
</template>

<script>
import { apiFetchInviteStatistics, apiFetchInviteCode } from './apidir/api'

import scrollMixin from '@/hooks/scroll.mixin.js'
import getWords from '@/assets/packageAssets/words/index.js'

const DEFAULT_TASKS = [
  { iconType: 'call', title: '', desc: '', reward: 0 },
  { iconType: 'pay', title: '', desc: '', reward: 0 },
]

// btn.png 的宽高比，用于占位 spacer 计算固定按钮所需高度
const BTN_RATIO = 294 / 1056

// postcss-pxtorem 基准（与 config/rem-root-value.js 一致），用于把设计稿 px 换算成真实 px
const REM_ROOT_VALUE = 37.5

// 头部高度(390) - 重叠上移(80) = main-card 顶部距页面顶部的距离（设计稿 px）
const MAIN_CARD_TOP_DESIGN_PX = 390 - 80

// 取当前 1rem 对应的真实 px（flexible 设置 html font-size = clientWidth / 10）
function getRemPx() {
  return parseFloat(document.documentElement.style.fontSize) || 0
}

export default {
  name: 'InviteEarn',
  mixins: [scrollMixin],
  data() {
    return {
      homeData: { totalInvitees: 0, coinsEarned: 0, tasks: [] },
      inviteCode: '',
      loading: false,
      BTN_RATIO,
      viewportHeight: window.innerHeight || 0,
      // main-card 顶部距视口顶部的真实 px，初始按 rem 基准估算，挂载后实测校正
      mainCardTop: (MAIN_CARD_TOP_DESIGN_PX / REM_ROOT_VALUE) * getRemPx(),
      // 是否已完成实测校正；未完成时用 CSS 兜底值，避免间隙闪现
      mainCardMeasured: false,
    }
  },
  computed: {
    isEchoVariant() {
      return this.packageName === 'echo'
    },
    heroBg() {
      try {
        return this.isEchoVariant ? require('./images/bg-gems.webp') : require('./images/bg-coins.webp')
      } catch (e) {
        return ''
      }
    },
    totalReward() {
      if (!this.homeData.tasks || !this.homeData.tasks.length) {
        return '--'
      }
      return this.homeData.tasks.reduce((sum, t) => sum + (t.reward || 0), 0)
    },
    coinsWord() {
      const words = getWords(this.packageName) || {}
      return words.coins || ''
    },
    mainCardMinHeight() {
      return `calc(${this.viewportHeight}px - ${this.mainCardTop}px)`
    },
  },
  created() {
    this.applyDefaultTasks()
    this.fetchHome()
    this.fetchInviteCode()
    this.traceAction({ action: 'click', aposition: 'entrance', avalue: 'home_page', campaign: 'invite_male_users_to_earn' })
  },
  mounted() {
    this.updateViewportHeight()
    this.$nextTick(this.updateLayout)
    window.addEventListener('resize', this.handleResize)
    window.addEventListener('orientationchange', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
    window.removeEventListener('orientationchange', this.handleResize)
  },
  methods: {
    updateViewportHeight() {
      this.viewportHeight = window.innerHeight || this.viewportHeight
    },
    handleResize() {
      this.updateViewportHeight()
      // flexible 的 rem 刷新有 300ms 防抖，延后实测校正
      this.$nextTick(this.updateLayout)
      setTimeout(this.updateLayout, 350)
    },
    updateLayout() {
      // 实测 main-card 顶部位置，校正 rem 换算与设计稿差异
      const el = this.$refs.mainCard
      if (el && typeof el.getBoundingClientRect === 'function') {
        const top = el.getBoundingClientRect().top
        if (top > 0) this.mainCardTop = top
        this.mainCardMeasured = true
      }
    },
    taskIconSrc(index) {
      try {
        return index === 0 ? require('./images/earn01.webp') : require('./images/earn02.webp')
      } catch (e) {
        return ''
      }
    },
    applyDefaultTasks() {
      this.homeData.tasks = DEFAULT_TASKS.map((t) => ({
        iconType: t.iconType,
        title: t.title,
        desc: t.desc,
        reward: t.reward,
      }))
      this.homeData.tasks[0].title = this.$t('lang.InviteEarn.k010')
      this.homeData.tasks[0].desc = this.$t('lang.InviteEarn.k011')
      this.homeData.tasks[1].title = this.$t('lang.InviteEarn.k012')
      this.homeData.tasks[1].desc = this.$t('lang.InviteEarn.k013')
    },
    fetchHome() {
      if (this.loading) return
      this.loading = true
      apiFetchInviteStatistics({})
        .then((res) => {
          if (!res || res.status !== 200) return
          const data = res.data || {}
          this.homeData.totalInvitees = data.inviteCount || 0
          this.homeData.coinsEarned = data.inviteReward || 0
          if (this.homeData.tasks[0]) {
            this.homeData.tasks[0].reward = data.firstCallReward || 0
          }
          if (this.homeData.tasks[1]) {
            this.homeData.tasks[1].reward = data.firstRechargeReward || 0
          }
        })
        .catch(() => {
          // 接口未就绪时保留默认数据
        })
        .finally(() => {
          this.loading = false
        })
    },
    fetchInviteCode() {
      apiFetchInviteCode({})
        .then((res) => {
          if (!res || res.status !== 200) return
          this.inviteCode = (res.data && res.data.code) || ''
        })
        .catch(() => {})
    },
    handleInvite() {
      this.traceAction({ action: 'click', aposition: 'button', avalue: 'share', campaign: 'invite_male_users_to_earn' })
      if (this.inviteCode) {
        this.shareInvite()
        return
      }
      apiFetchInviteCode({})
        .then((res) => {
          if (!res || res.status !== 200) return
          this.inviteCode = (res.data && res.data.code) || ''
          this.shareInvite()
        })
        .catch(() => {})
    },
    getShareTitle() {
      const m = {
        echo: 'Echo - Live video chat',
        joychat: 'Joychat - Live video chat',
        joyu: 'Joyu - Live video chat',
        kiko: 'Kiko - Live video chat',
        vava: 'Vava - Live video chat',
        vibeo: 'Vibeo - Live video chat',
        whonow: 'WhoNow - Live video chat',
      }
      return m[this.packageName] || m.vava
    },
    shareInvite() {
      const lang = this.$client.getAppInfoLang()
      const address = this.getMatchAddress()
      const appName = this.getAppName() || 'com.client.goparty'
      const enc = encodeURIComponent
      const query = `lang=${enc(lang)}&code=${enc(this.inviteCode || '')}&appName=${enc(appName)}`
      const url = `https://${address}/download_earn/index.html?${query}`
      const des = this.$t('lang.InviteEarn.k015') || 'Instant 1v1 video chats with real people! 🚀 Match in exactly 1 second. Get it here'
      this.$client.copyLink(`${des} # ${url}`, this.$t('lang.CommonModule.k007'))
      try {
        shareIntent.postMessage(JSON.stringify({ title: this.getShareTitle(), description: des, url }))
      } catch (err) {
        console.log('try catch', err)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.invite-earn-root {
  position: relative;
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: #5b7ef6;

  .custom-nav-block {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 100;
    width: 100%;

    &.nav-default {
      background: transparent;
    }

    &.nav-scrolling {
      background: #5b7ef6;
    }

    .van-bar {
      background: transparent;
    }

    .left-nav {
      width: 24px;
      height: 24px;
    }
  }

  .event-head {
    position: relative;
    width: 100%;
    height: 390px;
    flex-shrink: 0;
    background: #5b7ef6;

    .hero-bg {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
      pointer-events: none;
    }

    .head-content {
      position: relative;
      z-index: 1;
      display: flex;
      flex-direction: column;
      align-items: center;

      .title-banner {
        position: relative;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;

        .title-banner-bg {
          width: 100%;
          height: auto;
          display: block;
        }

        .title-banner-text {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          max-width: 240px;
          width: 100%;
          text-align: center;

          .title-banner-label {
            margin: 0;
            font-family: 'Roboto-Regular';
            font-weight: 700;
            font-size: 22px;
            line-height: 30px;
            color: #ffffff;
            text-align: center;
            word-break: break-word;
            white-space: normal;
            text-shadow: 0 4px 3px rgba(11, 23, 69, 0.4);
          }

          ::v-deep .title-reward {
            font-style: italic;
            color: #fbdd69;
          }
        }
      }
    }
  }

  .event-body {
    position: relative;
    z-index: 1;
    margin-top: -80px;
    padding: 0 10px;

    .main-card {
      position: relative;
      padding: 10px 10px 0;
      background: rgba(255, 255, 255, 0.9);
      backdrop-filter: blur(19.55px);
      border: 2px solid rgba(126, 144, 249, 0.2);
      border-bottom: 0;
      border-radius: 24px 24px 0 0;
      display: flex;
      flex-direction: column;
      // 兜底初始值：实测校正前的首帧用此值，避免间隙闪现；inline 值在实测后覆盖
      min-height: calc(100vh - 8.267rem);

      .reward-progress {
        padding: 17px 16px 0;

        .section-title {
          display: flex;
          align-items: center;
          justify-content: center;

          .title-star {
            width: 78px;
            height: 8px;
            background: url('./images/line.webp') center / contain no-repeat;

            &:first-child {
              transform: scaleX(-1);
            }
          }

          .title-text {
            margin: 0 10px;
            font-family: 'Roboto-Regular';
            font-weight: 700;
            font-size: 16px;
            line-height: 22px;
            color: #0b2fb6;
            text-align: center;
          }
        }

        .stats-row {
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 20px 0 24px;

          .stat-col {
            flex: 1;
            display: flex;
            flex-direction: column;
            align-items: center;

            .stat-value {
              display: flex;
              align-items: center;
              font-family: 'Inter-Regular';
              font-weight: 700;
              font-size: 32px;
              line-height: 38px;
              color: #0b1745;

              .stat-coin {
                margin-left: 4px;
                width: 32px;
                height: 32px;
                object-fit: contain;
              }
            }

            .stat-label {
              margin-top: 4px;
              font-family: 'Roboto-Regular';
              font-weight: 500;
              font-size: 12px;
              line-height: 16px;
              color: #61709c;
              text-align: center;
            }
          }

          .stat-divider {
            width: 1px;
            height: 48px;
            background: #c2d4f5;
          }
        }
      }

      .how-to-earn {
        padding: 0 16px 16px;

        .section-title-left {
          justify-content: flex-start;
          margin-bottom: 12px;

          .title-star {
            display: none;
          }

          .title-text {
            margin: 0;
            font-family: 'Roboto-Regular';
            font-weight: 700;
            font-size: 15px;
            line-height: 21px;
            color: #0b1745;
            -webkit-text-fill-color: #0b1745;
          }
        }

        .task-list {
          display: flex;
          flex-direction: column;
        }

        .task-item {
          display: flex;
          align-items: center;
          padding: 12px 0;
          border-bottom: 1px solid #dee5f8;

          .task-icon {
            flex-shrink: 0;
            width: 40px;
            height: 40px;
            object-fit: contain;
          }

          .task-text {
            flex: 1;
            min-width: 0;
            margin-left: 12px;

            .task-title {
              font-family: 'Roboto-Regular';
              font-weight: 700;
              font-size: 15px;
              line-height: 20px;
              color: #0b1745;
            }

            .task-desc {
              margin-top: 2px;
              font-family: 'Roboto-Regular';
              font-weight: 500;
              font-size: 12px;
              line-height: 16px;
              color: #61709c;
            }
          }

          .task-reward {
            display: flex;
            align-items: center;
            flex-shrink: 0;

            .reward-num {
              font-family: 'Inter-Regular';
              font-weight: 700;
              font-size: 16px;
              line-height: 22px;
              color: #4b2e00;
            }

            .reward-coin {
              margin-left: 4px;
              width: 20px;
              height: 20px;
              object-fit: contain;
            }
          }
        }
      }
    }

    .invite-btn-spacer {
      width: 100%;
      height: 150px;
    }
  }

  .invite-btn-fixed {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 10;
    padding: 0 10px;

    .invite-btn {
      position: relative;
      display: block;
      width: 100%;
      padding: 0;
      border: none;
      background: transparent;
      cursor: pointer;

      .invite-btn-bg {
        width: 100%;
        height: auto;
        display: block;
      }

      .invite-btn-text {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);

        display: flex;
        align-items: center;
        justify-content: center;

        font-family: 'Roboto-Regular';
        font-weight: 700;
        font-size: 20px;
        line-height: 26px;
        color: #743d00;
      }
    }

    .invite-btn-block {
      width: 100%;
      height: 32px;
    }
  }
}
</style>

<style lang="scss">
html[lang='ar'],
html[lang='fa'],
html[lang='he'] {
  .invite-earn-root {
    .event-body {
      .main-card {
        .reward-progress .stats-row {
          .stat-col .stat-value .stat-coin {
            margin-left: 0;
            margin-right: 4px;
          }
        }

        .reward-progress .section-title {
          .title-star:first-child {
            transform: none;
          }

          .title-star:last-child {
            transform: scaleX(-1);
          }
        }

        .how-to-earn {
          .section-title-left {
            justify-content: flex-end;
          }

          .task-item {
            .task-text {
              margin-left: 0;
              margin-right: 12px;
            }

            .task-reward .reward-coin {
              margin-left: 0;
              margin-right: 4px;
            }
          }
        }
      }
    }
  }
}
</style>
